import {
  isPaisRendererDocument,
  isScheduleOfValuesDoc,
} from "../components/permitForms/permitFormHelpers";
import { getSpecialForm } from "../components/permitForms/specialFormsMap";

export const loadComponent = async (selectedDocument, documentPayload = null) => {
  const schemaType = selectedDocument?.schema_type;

  if (!selectedDocument) {
    return null;
  }
  
  const specialForm = getSpecialForm(selectedDocument);
  if (specialForm) {
    return await specialForm.loadComponent();
  }

  if (selectedDocument?.is_noc) {
    return await import(`../components/permitForms/global/CreatingNocForm`);
  }

  if (isPaisRendererDocument(selectedDocument, documentPayload)) {
    return await import(`../components/permitForms/SimplePaisForms`);
  }

  if (schemaType === "complex") {
    return await import(`../components/permitForms/DynamicPermitForm`);
  }

  if (!isScheduleOfValuesDoc(selectedDocument)) {
    return await import(`../components/permitForms/SimplePermitForm`);
  }

  return null;
};